<template>
  <div class="addCollar main-content">
    <!-- 数据表格 -->
    <div class="tableStyle">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="collar"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :data="baseData"
        :columns="bankColumnList"
        :valid-config="{ message: 'none' }"
        :toolbar="{}"
        :max-height="$store.state.app.tableHeight"
        :edit-rules="tableEditRules"
        :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
      >
        <template v-slot:buttons>
          <vxe-button
            @click="exportFile()"
            type="primary"
            icon="el-icon-upload"
            class="vxe-btn-primary"
            >{{ $t('costConfirmationList.router.export') }}</vxe-button
          >
          <vxe-button
            @click="insertEvent(-1)"
            type="primary"
            icon="el-icon-plus"
            class="vxe-btn-primary"
            >{{ $t('functionBtn.add') }}</vxe-button
          >
        </template>
      </vxe-grid>
      <footer class="fixed-bottom-btnList">
        <el-button class="fixed-bottom-btn" type="primary" @click="handleValid()">{{
          $t('functionBtn.save')
        }}</el-button>
      </footer>
    </div>
  </div>
</template>
<script>
  // import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import { topDataRules } from './rules/rules';
  import { tableEditRules } from './rules/tableRules';
  import { dateFormat } from '@/filters';
  import API from '@/api/masterData/supplyChain';
  import collarAPI from '@/api/productCenter/collarDetails';
  import DataBaseAPI from '@/api/dataBase';
  // import inputNumber from '@/components/form-item/input-number';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import DictSelect from '@/components/DictSelect';

  export default {
    name: 'editCollar',
    components: {},
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        lang: (state) => state.lang.language,
      }),

      bankColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          //序号
          {
            type: 'seq',
            // field: "sortNo",
            title: this.$t('collarDetailsList.column.sortNo'),
            width: 60,
          },
          //商品类别
          {
            field: 'goodsType',
            title: this.$t('collarDetailsList.column.goodsType'),
            /* 自定义列为select组件样例 */
            editRender: { name: 'ElSelect' },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.goodsTypeName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <dict-select
                    placeholder={this.$t('collarDetailsList.column.selectPlaceholder')}
                    type="productType"
                    value={row['goodsType']}
                    onChange={(val, label) => this.handleChangeInput(val, label, row, 'goodsType')}
                  ></dict-select>,
                ];
              },
            },
          },
          //商品编码
          {
            field: 'productCode',
            title: this.$t('collarDetailsList.column.productCode'),
            editRender: { name: 'ElSelect' },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.productName}</span>];
              },
              edit: ({ row }) => {
                if (row.goodsType) {
                  return [
                    <ajax-select
                      placeholder={this.$t('collarDetailsList.column.productCode')}
                      value={row.productCode}
                      apiUrl={collarAPI.COLLARDETAILS_PRODUCTCODE_API}
                      apiData={{ productType: row.goodsType }}
                      filterable={true}
                      valueType="object"
                      valueKey="value"
                      labelKey="label"
                      method="get"
                      onChange={(val) => this.handleChangeInput(val, val, row, 'productCode')}
                    ></ajax-select>,
                  ];
                }
              },
            },
          },
          //供应商编号
          {
            field: 'partnerCode',
            title: this.$t('collarDetailsList.column.partnerCode'),
            editRender: { name: 'ElSelect' },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.partnerName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <ajax-select
                    placeholder={this.$t('collarDetailsList.column.selectPlaceholder')}
                    value={row.partnerCode}
                    apiUrl={DataBaseAPI.PARTNER_LIST_API}
                    // partnerType: "HZHB03",
                    apiData={{ requestStatus: 'ZT03' }}
                    filterable={true}
                    valueType="object"
                    valueKey="partnerCode"
                    labelKey="partnerZhName"
                    method="post"
                    onChange={(val) => this.handleChangeInput(val, val, row, 'partnerCode')}
                  ></ajax-select>,
                ];
              },
            },
          },
          //领用数量
          {
            field: 'productCount',
            title: this.$t('collarDetailsList.column.productCount'),
            editRender: { name: 'ElInput', default: '' },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.productCount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['productCount']}
                    precision={2}
                    max={99999999999999999.99}
                    onInput={(val) => this.handleChangeNumber(val, row, 'productCount')}
                  ></input-number>,
                ];
              },
            },
          },
          //回单号
          {
            field: 'receiptNo',
            title: this.$t('collarDetailsList.column.receiptNo'),
            editRender: { name: 'ElInput', default: '' },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.receiptNo}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['receiptNo']}
                    onInput={(val) => this.handleChangeNumber(val, row, 'receiptNo')}
                  ></input-number>,
                ];
              },
            },
          },
          //出库仓库
          {
            field: 'storageCode',
            title: this.$t('collarDetailsList.column.storageCode'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          //出库日期
          {
            field: 'outboundDate',
            title: this.$t('collarDetailsList.column.outboundDate'),
            editRender: {
              name: 'ElDatePicker',
              props: { clearable: true, valueFormat: 'yyyy-MM-dd' },
            },
            width: '140',
          },
          //单位
          /*{ 
          field: "productUnit",
          title: this.$t("collarDetailsList.column.productUnit"),
          editRender: {
            name: "ElSelect",
          },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [<span>{row.basicUnit}</span>];
            },
            edit: ({ row }) => {
              return [
                <dict-select
                  placeholder={this.$t(
                    "collarDetailsList.column.selectPlaceholder"
                  )}
                  type="produce_basic_unit"
                  value={row["basicUnit"]}
                  onChange={(val, label) =>
                    this.handleChangeInput(val, label, row, "basicUnit")
                  }
                ></dict-select>
              ];
            }
          }
        }, */
          //明细标志
          {
            field: 'detailLabel',
            title: this.$t('collarDetailsList.column.detailLabel'),
            /* 自定义列为select组件样例 */
            editRender: {
              name: 'ElSelect',
              options: this.identification,
              props: { clearable: true },
            },
          },
          {
            //操作人
            field: 'createPersonNo',
            title: this.$t('collarDetailsList.column.createPersonNo'),
            visible: true,
            width: 140,
          },
          {
            //业务部门
            field: 'recipientsDepartmentName',
            title: this.$t('collarDetailsList.column.recipientsDepartmentCode'),
            visible: true,
            width: 140,
          },
          {
            //公司
            field: 'recipientsCompanyName',
            title: this.$t('collarDetailsList.column.companyName'),
            visible: true,
            width: 140,
          },
          //备注
          /* {
          field: "remark",
          title: this.$t("collarDetailsList.column.remark"),
          editRender: { name: "ElInput", props: { clearable: true } }
        } */
        ];
      },
    },
    data() {
      return {
        topDataRules: topDataRules,
        tableEditRules: tableEditRules,
        topData: {
          companyCode: '', // 操作人所在公司代码
          companyName: '', //操作人所在公司名称
          departmentCode: '', // 操作人所在业务部门
          departmentName: '', //操作人所在部门名称
          recipientsCompanyCode: '', //公司代码
          recipientsCompanyName: '', //公司名称
          recipientsDepartmentCode: '', //业务部门代码
          recipientsDepartmentName: '', //部门名称

          // departmentCodes:"",//登录人所在部门编号
          createPersonNo: '', //操作人
          createPersonName: '', //操作人名称
          createDate: dateFormat(new Date()), // 申请时间
          storageCode: '', // 出库仓库
          outboundDate: '', // 出库日期
          receiptNo: '', // 回单号
        },
        companyList: [], // 公司数据
        departmentList: [], // 部门数据
        requestByList: [], // 人员数据
        goodsTypeList: [], //商品类别数据
        partnerList: [], //合作伙伴
        baseData: [],
        goodsType: '',
        identification: [
          {
            label: '红冲退回',
            value: '红冲退回',
          },
        ],
      };
    },
    mounted() {
      this.getDictList();
      this.getData();
    },
    methods: {
      activeRowMethod() {
        return true;
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$XModal.confirm('是否在当前明细中新增一行数据?').then((type) => {
          if (type === 'confirm') {
            this.$refs.collar.validate().then(() => {
              let record = {};
              this.$refs.collar.insertAt(record, row).then(({ row }) => {
                row.createPersonNo = this.userInfo.userName;
                row.recipientsDepartmentName = this.userInfo.departmentName;
                row.recipientsCompanyName = this.userInfo.companyName;
                this.$refs.collar.setActiveRow(row);
              });
            });
          } else if (type === 'cancel') {
            this.$baseRequest.linkRouteUrl('/production/collarAdd', 'collarAdd', '');
          }
        });
      },
      // 初始化数据
      getData() {
        this.topData.createPersonNo = this.userInfo.userCode;
        this.topData.createPersonName = this.userInfo.userName;
        this.topData.companyName = this.userInfo.companyName;
        this.topData.companyCode = this.userInfo.companyCode;
        this.topData.departmentCode = this.userInfo.departmentCode;
        this.topData.departmentName = this.userInfo.departmentName;
      },
      // 获取字典值
      getDictList() {
        // const tenantCode = this.userInfo.tenantCode;
        // 获取公司，部门数据
        this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
          if (res.data.code === 0) {
            let companyList = res.data.data.personCompanyInfo;
            if (companyList.length > 0) {
              this.companyList = companyList.map((item) => {
                item['value'] = item.personCompanyCode;
                item['label'] = item.personCompanyName;
                return item;
              });
              this.topData.recipientsCompanyCode = this.companyList[0].value;
              this.topData.recipientsCompanyName = this.companyList[0].label;
            }
            let list = res.data.data.personDepartmentInfo;
            if (list.length > 0) {
              this.departmentList = list.map((item) => {
                item['value'] = item.personDepartmentCode;
                item['label'] = item.personDepartmentName;
                return item;
              });
              this.topData.recipientsDepartmentCode = this.departmentList[0].value;
              this.topData.recipientsDepartmentName = this.departmentList[0].label;
            }
          }
        });
        // 获取用户数据
        this.$axios.post(API.GET_LIST_PERSON, { personInfo: '' }).then((res) => {
          if (res.data.code === 0) {
            let list = res.data.data.personInfo;
            if (list.length > 0) {
              this.requestByList = list.map((item) => {
                item['value'] = item.id;
                item['label'] = item.personName;
                return item;
              });
            }
          }
        });
      },
      changeCompanyCode(val) {
        this.companyList.find((item) => {
          if (item.value === val.val) {
            this.topData.recipientsCompanyName = item.label;
          }
        });
      },
      changeDepartmentCode(val) {
        this.slipDepartmentList.find((item) => {
          if (item.value === val.val) {
            this.topData.recipientsDepartmentName = item.label;
          }
        });
      },
      // 表单变化
      handleChangeTopData(value, prop) {
        console.log(value, prop);
      },
      handleChangeNumber(val, row, type) {
        row[type] = val;
      },
      handleChangeInput(val, label, row, type) {
        if (type == 'goodsType') {
          row[type] = val;
          row.goodsTypeName = label;
          row.productCode = ' ';
          row.productName = ' ';
          row.goodsType = null;
          setTimeout(() => {
            row.goodsType = val;
          }, 10);
        }
        if (type == 'productCode') {
          row[type] = val.value;
          row.productName = val.label;
        }
        if (type == 'partnerCode') {
          row[type] = val.partnerCode;
          row.partnerName = val.partnerZhName;
        }
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('collarDetailsList.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.baseData[tableTpye] = this.$refs[tableTpye].getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('collarDetailsList.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('collarDetailsList.message.cancelled'),
            });
          });
      },
      handleValid() {
        // 顶部表单校验
        this.$refs.topData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            // 表格内容校验
            this.$refs.collar.validate(() => {
              this.handleSave();
            });
          }
        });
      },
      handleSave() {
        // this.loading.startLoading();
        // let params = Object.assign(this.topData);
        this.baseData = this.$refs.collar.getTableData().fullData;
        let insertList = [];
        for (let item of this.baseData) {
          delete item.goodsTypeName;
          insertList.push(Object.assign(item, this.topData));
        }
        this.$axios.post(collarAPI.COLLARDETAILS_SAVE_API, insertList).then((res) => {
          console.log(res);
          // this.loading.endLoading();
          // if(res.data.code === 0) {
          //   this.$message({ showClose: true, message: res.data.msg, type: "success" });
          // }
        });
      },
    },
  };
</script>
<style>
  .addCollar .isShowLabel .el-form-item__content {
    margin-left: 0 !important;
  }
  .addCollar .textOver label {
    line-height: unset;
  }
  .addCollar .dateInput .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: unset !important;
  }
</style>
<style scoped>
  .addCollar {
    padding-bottom: 100px;
  }
  .addCollar .el-select,
  .el-input {
    width: 100%;
  }
</style>
